import * as React from "react";
import Grid from "@mui/material/Grid";
import SummaryChart from "../ui/QC/SummaryChart";
import SummaryTable from "../ui/QC/SummaryTable";
import SummaryFilters from "../ui/QC/SummaryFilters";
import { useState, useEffect } from "react";
import { useIntl } from "react-intl";
import { useLoading } from "../../components/LoadingContext";

export default function Summary(props) {
  const intl = useIntl();
  const { setLoading } = useLoading();
  const [tableData, setTableData] = useState([]);
  const [totalDossierQty, setTotalDossierQty] = useState();
  const [checkedData, setCheckedData] = useState([]);
  const [styleCodes, setStyleCodes] = useState([]);
  const [fabricCodes, setFabricCodes] = useState([]);
  const [sizes, setSizes] = useState([]);
  const [checkedOutcomes, setCheckedOutcomes] = useState([]);
  const [tableStyleCodes, setTableStyleCodes] = useState([]);
  const [tableFabricCodes, setTableFabricCodes] = useState([]);
  const [tableSizes, setTableSizes] = useState([]);
  const [dataFromChild, setDataFromChild] = useState("");
  const [modelFromChild, setModelFromChild] = useState("");
  const [aspectFromChild, setAspectFromChild] = useState("");
  const [sizeFromChild, setSizeFromChild] = useState("");
  const [outcomeFromChild, setOutcomeFromChild] = useState("");
  const [filteredDataFromChild, setFilteredDataFromChild] = useState([]);
  const [chartData, setChartData] = useState([]);

  const [filters, setFilters] = useState({
    idAnagQCOutcome: null,
    styleCode: null,
    fabricCode: null,
    size: null,
  });

  function handleDataFromChild(data) {
    setDataFromChild(data);
  }

  function handleModelFromChild(data) {
    setModelFromChild(data);
  }

  function handleAspectFromChild(data) {
    setAspectFromChild(data);
  }

  function handleSizeFromChild(data) {
    setSizeFromChild(data);
  }

  function handleOutcomeFromChild(data) {
    setOutcomeFromChild(data);
  }

  function handleFilteredDataFromChild(data) {
    setFilteredDataFromChild(data);
  }

  useEffect(() => {
    getSummaryData();
  }, []);

  const getSummaryData = () => {
    var outcomes = props.outcomesData;
    var allRows = props.allRows;

    var tableDataList = [];
    var allOutcomesData = [];

    outcomes.forEach((outcome) => {
      var itemData = [];
      allRows.filter((item) => {
        if (item.idAnagQCOutcome == outcome.idAnagOutcome) {
          itemData.push({
            barcodeAndCheckDigit: item.barcodeAndCheckDigit,
            styleCode: item.styleCode,
            fabricCode: item.fabricCode,
            size: item.size,
            idAnagQCOutcome: item.idAnagQCOutcome,
            renderedQty: item.renderedQty,
            totalRowQty: item.totalRowQty,
            outcome: outcome.outcome,
          });
        }
      });
      allOutcomesData.push(itemData);
    });

    var styleCodes = [];
    var fabricCodes = [];
    var sizes = [];
    var checkedOutcomes = [];
    allOutcomesData.map((d) => {
      let sum = 0;
      for (let i = 0; i < d.length; i++) {
        sum += d[i].renderedQty;

        styleCodes.push({
          idAnagQCOutcome: d[i].idAnagQCOutcome,
          styleCode: d[i].styleCode,
          qty: d[i].renderedQty,
        });

        fabricCodes.push({
          idAnagQCOutcome: d[i].idAnagQCOutcome,
          fabricCode: d[i].fabricCode,
          qty: d[i].renderedQty,
        });

        sizes.push({
          idAnagQCOutcome: d[i].idAnagQCOutcome,
          size: d[i].size,
          qty: d[i].renderedQty,
        });

        checkedOutcomes.push({
          idAnagQCOutcome: d[i].idAnagQCOutcome,
          outcome: d[i].outcome,
          qty: d[i].renderedQty,
        });
      }

      tableDataList.push({
        idAnagOutcome: d[0]?.idAnagQCOutcome,
        outcome: d[0]?.outcome,
        totQty: sum,
      });
    });

    let totalQty = 0;
    tableDataList.forEach((el) => (totalQty += el.totQty));
    setTotalDossierQty(totalQty);
    setTableData(tableDataList);

    handleStyleCodes(styleCodes);
    handleFabricCodes(fabricCodes);
    handleSizes(sizes);
    handleCheckedOutcomes(checkedOutcomes);

    var checkedRows = [];
    allRows.map((x) => {
      if (x.idAnagQCOutcome != null) {
        checkedRows.push(x);
      }
    });
  };

  const handleStyleCodes = (styleCodes) => {
    var models = [];
    const distinctModels = [...new Set(styleCodes.map((x) => x.styleCode))];
    distinctModels.map((x) => {
      models.push({ value: x, text: x });
    });
    setStyleCodes(models);
  };

  const handleFabricCodes = (fabricCodes) => {
    var aspects = [];
    const distinctFabricCodes = [
      ...new Set(fabricCodes.map((x) => x.fabricCode)),
    ];
    distinctFabricCodes.map((x) => {
      aspects.push({ value: x, text: x });
    });
    setFabricCodes(aspects);
  };

  const handleSizes = (sizesData) => {
    var sizes = [];
    const distinctSizes = [...new Set(sizesData.map((x) => x.size))];
    distinctSizes.map((x) => {
      sizes.push({ value: x, text: x });
    });
    setSizes(sizes);
  };

  const handleCheckedOutcomes = (checkedOutcomes) => {
    var data = [];
    checkedOutcomes.map((x) => {
      data.push({ value: x.idAnagQCOutcome, text: x.outcome });
    });

    let mapObj = new Map(
      data.map((obj) => {
        return [JSON.stringify(obj), obj];
      })
    );
    let output = Array.from(mapObj.values());
    setCheckedOutcomes(output);
  };

  useEffect(() => {
    let data = handleFilterDataset(props.allRows);
    createDataByArticle(data);
  }, [props.allRows, filters]);

  useEffect(() => {
    setFilters({
      idAnagQCOutcome: outcomeFromChild,
      styleCode: modelFromChild,
      fabricCode: aspectFromChild,
      size: sizeFromChild,
    });
  }, [
    dataFromChild,
    modelFromChild,
    aspectFromChild,
    sizeFromChild,
    outcomeFromChild,
  ]);

  const handleFilterDataset = (data) => {
    if (filters.idAnagQCOutcome === 0) {
      return data.filter((x) => x.idAnagQCOutcome == null);
    }

    if (
      filters.styleCode == null &&
      filters.fabricCode == null &&
      filters.size == null &&
      (filters.idAnagQCOutcome == null || filters.idAnagQCOutcome == "")
    ) {
      return data;
    }

    if (
      filters.styleCode.length == 0 &&
      filters.fabricCode.length == 0 &&
      filters.size.length == 0 &&
      (filters.idAnagQCOutcome == null || filters.idAnagQCOutcome == "")
    ) {
      return data;
    }

    return (data = data.filter(function (item) {
      for (var key in filters) {
        if (filters[key].length == 0) {
          continue;
        } else {
          if (item[key] === undefined || item[key] != filters[key]) {
            return false;
          }
          return true;
        }
      }
    }));
  };

  function createDataByArticle(filteredData) {
    let checkedItems = [];
    filteredData.map((x) => {
      if (x.idAnagQCOutcome != null) {
        checkedItems.push(x);
      }
    });

    let models = handleModelsGrouping(checkedItems);
    let aspects = handleAspectsGrouping(checkedItems);
    let sizes = handleSizesGrouping(checkedItems);

    let outcomes = handleOutcomesGrouping(filteredData);

    let dataset = outcomes;
    if (dataFromChild == "model") {
      dataset = models;
    } else if (dataFromChild == "aspect") {
      dataset = aspects;
    } else if (dataFromChild == "size") {
      dataset = sizes;
    } else if (dataFromChild == "outcome") {
      dataset = outcomes;
    }

    setChartData(dataset);
  }

  const handleModelsGrouping = (data) => {
    var models = [];

    data.reduce(function (res, value) {
      if (!res[value.styleCode]) {
        res[value.styleCode] = { value: value.styleCode, renderedQty: 0 };
        models.push(res[value.styleCode]);
      }
      res[value.styleCode].renderedQty += value.renderedQty;
      return res;
    }, {});
    return models;
  };

  const handleAspectsGrouping = (data) => {
    var aspects = [];

    data.reduce(function (res, value) {
      if (!res[value.fabricCode]) {
        res[value.fabricCode] = { value: value.fabricCode, renderedQty: 0 };
        aspects.push(res[value.fabricCode]);
      }
      res[value.fabricCode].renderedQty += value.renderedQty;
      return res;
    }, {});
    return aspects;
  };

  const handleSizesGrouping = (data) => {
    var sizes = [];

    data.reduce(function (res, value) {
      if (!res[value.size]) {
        res[value.size] = { value: value.size, renderedQty: 0 };
        sizes.push(res[value.size]);
      }
      res[value.size].renderedQty += value.renderedQty;
      return res;
    }, {});
    return sizes;
  };

  const handleOutcomesGrouping = (data) => {
    var outcomes = [];

    data.reduce(function (res, value) {
      if (!res[value.idAnagQCOutcome]) {
        res[value.idAnagQCOutcome] = {
          value: value.idAnagQCOutcome,
          renderedQty: 0,
        };
        outcomes.push(res[value.idAnagQCOutcome]);
      }
      res[value.idAnagQCOutcome].renderedQty += value.renderedQty;
      return res;
    }, {});
    return outcomes;
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <SummaryFilters
          styleCodes={styleCodes}
          fabricCodes={fabricCodes}
          sizes={sizes}
          checkedOutcomes={checkedOutcomes}
          sendDataToParent={handleDataFromChild}
          sendModelToParent={handleModelFromChild}
          sendAspectToParent={handleAspectFromChild}
          sendSizeToParent={handleSizeFromChild}
          sendOutcomeToParent={handleOutcomeFromChild}
        />
      </Grid>
      <Grid container spacing={1.5} sx={{ m: 2}}>
        <Grid item xs={3}>
          <SummaryTable
            data={tableData}
            totalQty={totalDossierQty}
            styleCodes={tableStyleCodes}
            fabricCodes={tableFabricCodes}
            sizes={tableSizes}
            checkedOutcomes={checkedOutcomes}
            selectedChart={dataFromChild}
            selectedModel={modelFromChild}
            selectedAspect={aspectFromChild}
            selectedSize={sizeFromChild}
            selectedOutcome={outcomeFromChild}
            allRows={props.allRows}
            rows={chartData}
            sendFilteredDataToParent={handleFilteredDataFromChild}
            outcomesInfo={props.outcomesData}
          />
        </Grid>
        <Grid item xs={9} sx={{height:'100000px'}}>
          <SummaryChart
            data={tableData}
            totalQty={totalDossierQty}
            styleCodes={tableStyleCodes}
            fabricCodes={tableFabricCodes}
            sizes={tableSizes}
            checkedOutcomes={checkedOutcomes}
            selectedChart={dataFromChild}
            selectedModel={modelFromChild}
            selectedAspect={aspectFromChild}
            selectedSize={sizeFromChild}
            selectedOutcome={outcomeFromChild}
            filteredData={chartData}
            outcomesInfo={props.outcomesData}
          />
        </Grid>
      </Grid>
    </Grid>
  );
}
